module.exports = __webpack_public_path__ + "img/Arrow.d59b8fbe.svg";